import { useGetConfigurationSettingsPromptQuery } from 'src/services';

// Fetches the prompt/form-field payload for whichever settings version is
// currently active.
export const useConfigurationPrompt = (
  id: string,
  activeSettingsId: string | undefined,
  isReady: boolean,
) => {
  const {
    currentData: configurationSettingsPrompt,
    isLoading: isLoadingConfigurationSettingsPrompt,
    isFetching: isFetchingConfigurationSettingsPrompt,
  } = useGetConfigurationSettingsPromptQuery(
    { project_id: id, settings_id: activeSettingsId },
    {
      skip: !Boolean(id && activeSettingsId && isReady),
      refetchOnMountOrArgChange: true,
    },
  ) as any;

  return {
    configurationSettingsPrompt,
    isLoadingConfigurationSettingsPrompt,
    isFetchingConfigurationSettingsPrompt,
  };
};
